export const environment = {
  production: false,

  msalInstaceConfiguration: {
    clientId: 'afc8efad-b17a-4139-9607-4824516d456f',
    authority: 'https://login.microsoftonline.com/889ece36-85c6-46c8-a7bd-b9c04d57ddb2',
    redirectUri: '/',
    postLogoutRedirectUri: '/'
  },

  msalInterceptionConfigFactory: {
    graphMicrosoft: 'https://graph.microsoft.com/v1.0/me',
    urlApiBfarApp: 'https://aps-app-cipsapi-bs-dev.azurewebsites.net/**',
    scopeBfarApp: 'api://afc8efad-b17a-4139-9607-4824516d456f/access_as_user',
    urlApiTesteBfarApp: 'http://localhost:8080/**',
  },

  apiUrlBase: 'https://aps-app-cipsapi-bs-dev.azurewebsites.net/api',
  // apiUrlBase: 'http://localhost:8080/api',

  apiUrl: {
    protocolo: '/v1/protocolo',
    logImportacao: '/v1/logimportacao',
  },

  versao: '1.2.1-DEV'

};
